import React, { Component } from 'react';
import '../css/components/ContenedorFijo.css';

class ContenedorFijo extends Component {

	constructor(props) {
		super(props);
		this.classNameContainer = 'contenedor-fijo__container-zp';
		this.classNameContainer = (this.props.paddingDesktop)?
			this.classNameContainer + " contenedor-fijo__div-padding-desktop": this.classNameContainer;
		this.classNameContainer = (this.props.paddingMobile)?
			this.classNameContainer + " contenedor-fijo__div-padding-mobile": this.classNameContainer;
		this.classNameContainer = (this.props.classNameComp)?
			this.classNameContainer + " " + this.props.classNameComp: this.classNameContainer;
	}

	render() {
		return (
			<div className={this.classNameContainer}>
				<div className="contenedor-fijo__div-container-desktop">
					{this.props.children}
				</div>
			</div>
		);
	}
}

export default ContenedorFijo;



// WEBPACK FOOTER //
// ./src/components/ContenedorFijo.js